import { ITranslations } from 'types/common';
import { SearchCoverageTransFields } from './types';
import en from 'translations/en/searchCoverage.json';
import pl from 'translations/pl/searchCoverage.json';
import sl from 'translations/sl/searchCoverage.json';

export const searchCoverageTranslations: ITranslations<SearchCoverageTransFields> = {
  name: 'searchCoverage',
  en,
  pl,
  sl,
};
